import React from 'react';
import './App.css';
import SearchBar from '../SearchBar/SearchBar.js';
import BusinessList from '../BusinessList/BusinessList.js';

const business = {
  imageSrc: 'https://content.codecademy.com/programs/react/ravenous/pizza.jpg',
  name: 'MarginOtto Pizzeria',
  address: '1010 Paddington Way',
  city: 'Flavortown',
  state: 'NY',
  zipCode: '10101',
  category: 'Italian',
  rating: 4.5,
  reviewCount: 90
}

const businessList = [
  business, 
  business, 
  business, 
  business,
  business,
  business ];

class App extends React.Component {
  render() {
    return (
      <main className='main'>
        <header className='main-header'>
          <h1>ravenous</h1>
        </header>
        <SearchBar />
        <BusinessList business={businessList}/>
      </main>
    )
  }
}

export default App;
